import { get } from "./base";

export function getComponents() {
  return get("components");
}
